import axios from "axios";

export default axios.create({
  baseURL: "/stipendium/stipac/api",
  headers: {
    "Content-type": "application/json"
  }
});